import { useTheme } from '@mui/material'

export const PersonIcon = () => {
    const theme = useTheme()
    return (
        <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18Z"
                fill="#3D3D3D"
            />
            <path
                d="M25.9333 27.3337C25.9333 24.5845 22.5904 22.3559 18.4667 22.3559C14.3429 22.3559 11 24.5845 11 27.3337M18.4667 18.6225C15.7175 18.6225 13.4889 16.3939 13.4889 13.6448C13.4889 10.8956 15.7175 8.66699 18.4667 8.66699C21.2158 8.66699 23.4444 10.8956 23.4444 13.6448C23.4444 16.3939 21.2158 18.6225 18.4667 18.6225Z"
                stroke={theme.palette.primary.main}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
